import {getknowUsMoreAction} from 'store/Home';
import React, { Component } from "react";
import Banner from "views/know-us-more/components/LisitingBanner";
import KnowUsMore from "views/know-us-more/components/AllPortfolios"
import { connect } from "react-redux";
import FooterSection from "views/home/components/FooterSection";
import TrendingJobs1 from "views/home/img/courses/course1.png";
import "../css/Index.scss";
class Ilearn extends Component {
  constructor(props) {
    super(props);

    this.state = {
      courses: [],
    };
  }
  addDefaultSrc(ev) {
    ev.target.src =
    TrendingJobs1
  }
  async componentDidMount() {
    let response = await this.props.getknowUsMoreAction();
  }
  render() {
  return (
    <div className="mt-80px  lg:pt-8 md:pt-8">
      <div className="mx-auto container mb-4 lg:block md:block hidden">
        <ul className="bradcrumb flex">
          <li className="bradcrumb-li fsize14">Home </li>&nbsp;/&nbsp;
          <li className="text-black fsize14 font-semibold">
            Know us more
          </li>
        </ul>
      </div>

      <div className="mx-auto container lg:block md:block hidden">
        <Banner/>
      </div>

      <div className="mx-auto container">
       <KnowUsMore/>
      </div>

      <div className="mt-6 footer-css">
        <FooterSection courses={this.state.courses}/>
      </div>
    </div>
  );
  };
};
const mapStateToProps = (state) => {
  return {
    knowusmore: state.Home.home.KNOWUSMORE,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    getknowUsMoreAction: async () => await dispatch(getknowUsMoreAction()),

  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Ilearn);
// export default JobDetails;
